
export default function AccountSection() {
 
 return (
      <section className="pb-16 bg-white min-h-screen">
        <div style={{ minHeight: '300px' }}>
          <div data-mariana-integrations="/schedule/daily/48541?locations=48717"></div>
        </div>
      </section>
  );
}
